import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";
import { Preview, print } from "react-html2pdf";

export class AdmissionTriage extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      admissionstatus: "",
      admissionunit: "",
      admissionbed: "",
      patientName: localStorage.getItem("currentVisitName"),
      loading:false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
      $(".outPatient").hide();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
      $(".outPatient").show();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
  this.setState({
    loading: true
  })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/admission/main",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.data["status"]) {
          axios
            .post(
               +
                "billing/status/" +
                this.state.admissionunit +
                "/open",
              this.state,
              { headers: headers }
            )
            .then((res) => {
              //   const verified = res.data;
              console.log(res.data);
              this.setState({
                loading: false
              })
              if (res.data["status"]) {
                $(".alert-success").show();
                setTimeout(function () {
                  window.location.href = "/triage/init/dashboard";
                }, 3000);
              }
            })
            .catch((error) => {
              console.log(error);
            });

          if (this.state.admissionstatus == "No") {
            $("#notAdmitted").show();
            setTimeout(function () {
              window.location.href = "/triage/init/dashboard";
            }, 3000);
          } else {
            $(".HistoryModal").show();
          }
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  proceedEvent(event) {
    window.location.href = "/triage/init/dashboard";
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const { admissionstatus, admissionunit, admissionbed, patientName, loading } =
      this.state;
    return (
      <div>
        <Headers />
        <InterModularSidebar />

        <main class="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Admission Query
                  </p>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Is the Patient Set for Admission
                    </h6>
                    <select
                      id="mySelect2"
                      className="form-control"
                      onChange={this.handleChange}
                      value={admissionstatus}
                      name="admissionstatus"
                      required
                    >
                      <option selected disabled></option>
                      <option className="yesSelected" vslue="pending">
                        Yes
                      </option>
                      <option className="noSelected" vslue="no">
                        {" "}
                        No
                      </option>
                    </select>
                  </div>

                  <div className="hiddenPart" style={displayHidden}>
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Admission Unit
                      </h6>
                      <select
                        id="mySelect2"
                        className="form-control"
                        onChange={this.handleChange}
                        value={admissionunit}
                        name="admissionunit"
                      >
                        <option selected disabled></option>
                        <option value="gynecology">Gynecology Ward</option>
                        <option value="gynecology2">Gynecology Ward II</option>
                        <option value="labour">Labour Room </option>
                        <option value="delivery">Delivery </option>
                        <option value="theatre">Theatre </option>
                      </select>
                    </div>

                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Admission Bed{" "}
                      </h6>
                      <input
                        className="form-control"
                        onChange={this.handleChange}
                        value={admissionbed}
                        name="admissionbed"
                        type="text"
                      />
                    </div>
                  </div>

                  <div className="outPatient" style={displayHidden}>
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Reason for Outpatient{" "}
                      </h6>
                      <textarea
                        className="form-control"
                        onChange={this.handleChange}
                        value={admissionbed}
                        name="admissionbed"
                        type="text"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Patient Record Stored Successfully.
              </div>
              <div
                id="notAdmitted"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Patient Record Stored Successfully.
              </div>

              <div
                className="modal HistoryModal"
                style={autoscroll}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        {patientName}`s History Taking Modal
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                      <a
                        className="btn btn-success printDetails"
                        style={width100}
                        onClick={this.PrintWindow}
                      >
                        Print Details
                      </a>
                      <br />
                      <a
                        className="btn btn-danger proceed"
                        onClick={this.proceedEvent}
                        style={width100}
                      >
                        Proceed to Dashboard
                      </a>
                      <Preview id={"jsx-template"}>
                        <b>NAME: </b>
                        {patientName}
                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Admission Unit
                          </h6>
                          <input
                            type="text"
                            id="mySelect2"
                            className="form-control"
                            readOnly
                            value={admissionunit}
                            name="admissionunit"
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Admission Bed{" "}
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={admissionbed}
                            name="admissionbed"
                            type="text"
                          />
                        </div>
                      </Preview>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit' }
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default AdmissionTriage;
